import { ActivityEntityName, ComplianceFlagBoardRow, EntityViewDisplay } from '@jms/model';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { complianceFlagBulkCommands, handleComplianceFlagBulkCommand } from './commands/compliance.flag.bulk.close.command';
import { isOpenCompliance } from './commands/compliance.flag.command.support';
import { openComplianceFlagLine } from './commands/compliance.flag.row.open';
import { complianceFlagRowCommands } from './commands/compliance.flag.row.commands';

/**
 * Compliance board: compliance overdue Flags across every Service Plan, and one plan's under its Compliance tab
 * (`service.plan.compliance.relation`). Rows are flags: Book now and Close are the only writes.
 */
export const complianceFlagManifest = registerManifest<ComplianceFlagBoardRow>({
  entity: ActivityEntityName.ComplianceFlag,
  slug: 'compliance',
  board: {
    supportedDisplays: [EntityViewDisplay.Table],
    // Not `readonly`: that strips row commands, selection and bulk. Rows stay uneditable because every
    // field is readonly metadata and the only writes are the Flag commands below.
    defaults: {
      header: {
        title: 'Compliance',
        showSearch: true,
        showPaginator: true,
        showViewOptions: true,
        hideAdd: true,
      },
      itemInteraction: {
        navigate: openComplianceFlagLine,
        commands: complianceFlagRowCommands,
        selectable: {
          type: 'multiple',
          isSelectable: row => isOpenCompliance(row),
          bulkCommands: complianceFlagBulkCommands,
        },
      },
      bulk: {
        onCommand: handleComplianceFlagBulkCommand,
      },
    },
  },
});
